import React from "react";
import TextBox from "./TextBox";
import Util from "@/js/common/Util";
import AppContext from "@/js/common/AppContext";
// import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
// import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import Button from "../Button";

interface FileBoxProps {
    mode?: "readonly" | "disabled" | ""
    width?: number
    height: number
    fontSize: number
    fileExt: string[]
    maxFileSize?: number
    file?: File
    setFile: React.Dispatch<React.SetStateAction<File | undefined>>
}
const FileBox2 = ({ mode, width, height, fontSize, fileExt, maxFileSize, file, setFile }: FileBoxProps) => {
    const fileInput = React.useRef<HTMLInputElement>(null);

    // 파일 다운로드
    // const onClickDownload = () => {
    //     const tempFile = fileInput.current?.files?.[0];
    //     if (!tempFile) return;

    //     const fileUrl = URL.createObjectURL(tempFile);
    //     const tempLink = document.createElement('a');
    //     tempLink.href = fileUrl;
    //     tempLink.download = tempFile.name;

    //     tempLink.click();

    //     URL.revokeObjectURL(fileUrl);
    // };
    // 파일 업로드
    const onCickFileUpload = () => {
        if (!fileInput.current) {
            return;
        }
        fileInput.current.click();
    };
    // 파일 삭제
    const onCickFileDelete = () => {
        setFile(undefined);
        if (!fileInput.current) {
            return;
        }
        fileInput.current.value = "";
    };

    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files === null) {
            return;
        }

        // 파일 최대 사이즈 초과여부 체크
        if ((maxFileSize ? maxFileSize : AppContext.maxfileSize) < event.target.files[0].size) {
            AppContext.openAlert({
                title: "파일 용량 초과",
                msg: "파일 업로드 최대 허용 용량은 20MB 입니다. [선택파일 용량 : " + Math.floor(event.target.files[0].size / 1024 / 1024) + "MB]",
                icon: "error"
            });
            onCickFileDelete();
            return;
        }
        const extNm = event.target.files[0].name.substring(event.target.files[0].name.lastIndexOf(".") + 1).toLowerCase();
        if ((fileExt.length > 0 ? fileExt : AppContext.fileWhiteExt).indexOf(extNm) === -1) {
            AppContext.openAlert({
                title: "파일 확장자 체크",
                msg: extNm + " 확장자는 업로드 불가한 확장자의 파일입니다.",
                icon: "error"
            });
            onCickFileDelete();
            return;
        }
        setFile(event.target.files[0]);
    };

    return (
        <div className="dpFlx">
            <input type="file" style={{ display: "none" }} ref={fileInput} onChange={onChange} />
            <TextBox
                mode={mode}
                value={file === undefined ? "" : file.name}
                width={width}
                height={height}
                fontSize={fontSize}
                color="#222222"
                // borderColor="#BFBFBF" borderRadius={5}
                // borderOnColor="#BFBFBF"
                offColor="#666666"
                className="bd1 pl7"
                inputClassName="ls075"
                placeholder="첨부파일을 등록하세요."
                iconEl={
                    <div className="dpFlx aiC">
                        {/* 파일 등록 */}
                        {Util.isEmpty(file) && mode !== "readonly" &&
                            <Button
                                endIcon={<UploadFileIcon sx={{padding: 0, paddingLeft: "3px", paddingRight: "5px", fontSize: 22, color: "#2c3e50" }} />}
                                onClickFunc={(e: any) => {
                                    e.stopPropagation();
                                    onCickFileUpload();
                                }}
                            />
                        }
                        {/* 파일 삭제 */}
                        {Util.isNotEmpty(file) && mode !== "readonly" &&
                            <Button
                                endIcon={<DeleteForeverOutlinedIcon sx={{padding: 0, paddingLeft: "3px", paddingRight: "5px", fontSize: 25, color: "#fb4515"}} />}
                                onClickFunc={(e: any) => {
                                    e.stopPropagation();
                                    onCickFileDelete();
                                }}
                            />
                        }
                        {/* 파일 다운로드 */}
                        {/* {Util.isNotEmpty(file) &&
                            <Button
                                endIcon={<DownloadOutlinedIcon sx={{padding: 0, paddingLeft: "3px", fontSize: 25, color: "#007bff"}} />}
                                onClickFunc={(e: any) => {
                                    e.stopPropagation();
                                    onClickDownload();
                                }}
                            />
                        } */}
                    </div>
                }
            />
        </div>
    );
};
export default FileBox2;